// Small strip of house-mark badges used on the homepage.
// Each mark is a transparent PNG served from /public/marks.
import { useTheme } from "@/context/ThemeContext";

const MARKS = [
  { src: "/marks/since-1974.png", alt: "Trusted since 1974 · Three generations" },
  { src: "/marks/made-in-india.png", alt: "Made in India · Chickpet, Bangalore" },
  { src: "/marks/9-qualities.png", alt: "9 fabric qualities" },
  { src: "/marks/ready-stock.png", alt: "15 Lakh+ meters ready stock" },
  { src: "/marks/shade-matched.png", alt: "Precision shade-matched dyeing" },
  { src: "/marks/wholesale-only.png", alt: "Wholesale only — bulk orders" },
];

export default function TrustBadgesStrip({ theme }) {
  const { theme: appTheme } = useTheme();
  const dark = (theme || appTheme) === "dark";
  const bg = dark ? "var(--mp-surface)" : "var(--mp-paper)";
  const dividerColor = dark ? "rgba(206,143,78,0.25)" : "rgba(184,115,51,0.15)";
  return (
    <section
      className="py-14 lg:py-20 border-y"
      style={{ backgroundColor: bg, borderColor: dividerColor }}
      data-testid="trust-badges-strip"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p
          className="text-[10px] uppercase tracking-[0.28em] text-center mb-8 font-semibold"
          style={{
            fontFamily: "'Manrope', sans-serif",
            color: dark ? "rgba(243,239,230,0.55)" : "var(--mp-copper)",
          }}
        >
          The house of Mutha Paras &amp; Co.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-8 items-center">
          {MARKS.map((m) => (
            <div key={m.src} className="flex items-center justify-center">
              <img
                src={dark ? m.src.replace(".png", "_dark.png") : m.src}
                alt={m.alt}
                title={m.alt}
                className="h-14 lg:h-16 w-auto object-contain opacity-95 hover:opacity-100 transition-opacity"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
